const CATEGORIES = [
  {
    title: "Teatri storici",
    caption: "Sale con lampadari e velluto rosso",
    img: "https://images.unsplash.com/photo-1503095396549-807759245b35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Concerti live",
    caption: "Grandi palchi, luci, effetti speciali",
    img: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Eventi in piazza",
    caption: "Sagre, patronali, festival cittadini",
    img: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Matrimoni",
    caption: "Musica e spettacolo su misura",
    img: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Compleanni & Feste private",
    caption: "Intrattenimento intimo o esplosivo",
    img: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Feste aziendali",
    caption: "Convention, gala, team building",
    img: "https://images.unsplash.com/photo-1511578314322-379afb476865?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Feste di laurea",
    caption: "Cerimonie e after party",
    img: "https://images.unsplash.com/photo-1627556704290-2b1f5853ff78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Addii al celibato/nubilato",
    caption: "Performer, dj set, sorprese a tema",
    img: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Casting moda, TV, cinema",
    caption: "Selezione talenti e figuranti",
    img: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export default function CategoriesGallery() {
  return (
    <section
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24"
      data-testid="categories-gallery"
    >
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="av-eyebrow">Ogni tipo di evento</span>
          <h2 className="font-serif-display text-3xl sm:text-5xl mt-3 leading-tight max-w-3xl">
            Dal teatro storico all'<span className="italic text-[#E5A93C]">after party</span>,
            <br />
            ogni occasione ha il suo <span className="italic text-[#E5A93C]">palco</span>.
          </h2>
        </div>
        <p className="text-sm text-[#A39E93] max-w-sm">
          Concerti, sagre, matrimoni, compleanni, feste aziendali, lauree, addii,
          casting moda, tv e cinema — NMA Agency produce e cura ogni dettaglio.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {CATEGORIES.map((c, i) => (
          <article
            key={c.title}
            className="relative overflow-hidden rounded-2xl av-hairline border group cursor-default aspect-[4/5]"
            data-testid={`category-card-${i}`}
          >
            <img
              src={c.img}
              alt={c.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0908] via-[#0a0908]/50 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="av-eyebrow text-[10px] mb-2">✦ {i + 1 < 10 ? `0${i + 1}` : i + 1}</div>
              <h3 className="font-serif-display text-2xl text-[#F7F4EE] leading-tight">
                {c.title}
              </h3>
              <p className="text-xs text-[#F7F4EE]/70 mt-1">{c.caption}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
